export default {
  pvIds: {
    pick: 6828887,
    hot: 6827881,
    rank: 6827882,
    shop: 6827883,
    shopGoods: 6827884,
    play: 6827885,
    voucherGoods: 6827886,
    voucherUse: 6827888,
    voucherBuy: 0
  },
  actions: {
    discount: 'mall_m_redpacket_benefit_click',
    redget: 'mall_m_redpacket_redget_click'
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js